import gql from 'graphql-tag';

export default gql`
  mutation EditMeal($input: DailyTrackerEditMealInputType!) {
    dailyTracker {
      editMeal(input: $input) {
        ... on DailyTrackerEditMealSuccess {
          meal {
            id
          }
        }
        ... on ValidationException {
          code
          messages
          details {
            fieldName
            messages
          }
        }
        ... on UnauthorizedException {
          code
        }
        ... on Error {
          errorCode: code
          name
          description
        }
      }
    }
  }
`;
